<template>
  <div class="overview-main">
    <div class="sys-title">源网荷储一体化管控平台</div>
    <div class="main-content">
      <div class="div1">
        <img src="/images/flow/build.png" style="z-index: 3" />
        <img src="/images/flow/源.png" />
        <img src="/images/flow/网.png" />
        <img src="/images/flow/荷.png" />
        <img src="/images/flow/储.png" />
        <img src="/images/flow/充.png" />
        <img src="/images/flow/line/genTo.png" />
        <img src="/images/flow/line/gridTo.png" v-if="flowData.gridStatus === 0" />
        <img src="/images/flow/line/toGrid.png" v-if="flowData.gridStatus === 1" />
        <img src="/images/flow/line/toLoad.png" />
        <img src="/images/flow/line/toCharge.png" />
        <img src="/images/flow/line/toStorage.png" v-if="flowData.stoStatus === 1" />
        <img src="/images/flow/line/storageTo.png" v-if="flowData.stoStatus === 2" />
        <div class="charge-tip tip">
          <div class="tit">充</div>
          <div class="text">工作状态: 充电中</div>
          <div class="text">有功功率: 7 kW</div>
          <div class="text">日用电量: 45 kWh</div>
        </div>
        <div class="gen-tip tip">
          <div class="tit">源</div>
          <div class="text">工作状态: 发电中</div>
          <div class="text">有功功率: 65 kW</div>
          <div class="text">日发电量: 315 kWh</div>
        </div>
        <div class="grid-tip tip">
          <div class="tit">网</div>
          <div class="text">工作状态: 供给中</div>
          <div class="text">有功功率: 314 kW</div>
          <div class="text">日用电量: 3581 kWh</div>
        </div>
        <div class="load-tip tip">
          <div class="tit">荷</div>
          <div class="text">工作状态: 用电中</div>
          <div class="text">有功功率: 373 kW</div>
          <div class="text">日用电量: 3731 kWh</div>
        </div>
        <div class="storage-tip tip">
          <div class="tit">储</div>
          <div class="text">工作状态: 待机</div>
          <div class="text">有功功率: 0 kW</div>
          <div class="text">日充电量: 915 kWh</div>
          <div class="text">日放电量: 736 kWh</div>
        </div>
      </div>
      <div class="div3">
        <div class="title">园区数据</div>
        <div class="content">
          <div class="x-item" v-for="(item, index) in workshop" :key="index" :class="[item.noBg && 'no-bg']">
            <div class="x-item-replace">
              <img :src="item.img" alt="" class="x-item-img" />
              <div class="item-value-con">
                <div class="x-item-title" :class="item.noBg ? '' : 'color1'">
                  {{ item.title | miniValue }}
                </div>
                <div class="x-item-subTitle">{{ item.subTitle }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="div4">
        <div class="title">发电设备</div>
        <div class="content">
          <transition mode="out-in" name="slide" v-for="item in yDevices" :key="item.loadType">
            <div v-show="nowYType === item.loadType" :key="item.loadType" class="device-info-card">
              <div>
                <img :src="'/images/' + item.loadType + '.png'" />
                <div>
                  设备数量
                  <span class="num">{{ item.deviceCount }}</span>
                  台
                </div>
              </div>
              <div>
                <div class="type-name">{{ item.loadType }}</div>
                <div class="con">
                  <div class="col">
                    <div class="item">
                      <div class="val">{{ item.deviceCapaCity }}</div>
                      <div class="label">装机容量(MW)</div>
                    </div>
                    <div class="item">
                      <div class="val">{{ item.eleDayConsum }}</div>
                      <div class="label">今日发电量(kWh)</div>
                    </div>
                  </div>
                  <div class="col">
                    <div class="item">
                      <div class="val">{{ item.realPower }}</div>
                      <div class="label">实时功率(kW)</div>
                    </div>
                    <div class="item">
                      <div class="val">{{ item.eleDayCost }}</div>
                      <div class="label">今日收益(元)</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div class="div5">
        <div class="title">负荷设备</div>
        <div class="content">
          <transition mode="out-in" name="slide" v-for="item in hDevices" :key="item.loadType">
            <div v-show="nowHType === item.loadType" :key="item.loadType" class="device-info-card">
              <div>
                <img :src="'/images/' + item.loadType + '.png'" />
                <div>
                  设备数量
                  <span class="num">{{ item.deviceCount }}</span>
                  台
                </div>
              </div>
              <div>
                <div class="type-name">{{ item.loadType }}</div>
                <div class="con">
                  <div class="col">
                    <div class="item">
                      <div class="val">{{ item.deviceCapaCity }}</div>
                      <div class="label">装机容量(kW)</div>
                    </div>
                    <div class="item">
                      <div class="val">{{ item.eleDayConsum }}</div>
                      <div class="label">今日用电量(kWh)</div>
                    </div>
                  </div>
                  <div class="col">
                    <div class="item">
                      <div class="val">{{ item.realPower }}</div>
                      <div class="label">实时功率(kW)</div>
                    </div>
                    <div class="item">
                      <div class="val">{{ item.eleDayCost }}</div>
                      <div class="label">今日用电成本(元)</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div class="div6">
        <div class="title">储能设备</div>
        <div class="content">
          <transition mode="out-in" name="slide" v-for="item in cDevices" :key="item.loadType">
            <div v-show="nowCType === item.loadType" :key="item.loadType" class="device-info-card">
              <div>
                <img :src="'/images/' + item.loadType + '.png'" />
                <div>
                  设备数量
                  <span class="num">{{ item.deviceCount }}</span>
                  台
                </div>
              </div>
              <div>
                <div class="type-name">{{ item.loadType }}</div>
                <div class="con">
                  <div class="col">
                    <div class="item">
                      <div class="val">{{ item.deviceCapaCity }}</div>
                      <div class="label">装机容量(kW)</div>
                    </div>
                    <div class="item">
                      <div class="val">{{ item.eleDayConsum }}</div>
                      <div class="label">{{ item.loadType.includes("充电") ? "今日充电量" : "今日放电量" }}(kWh)</div>
                    </div>
                  </div>
                  <div class="col">
                    <div class="item">
                      <div class="val">{{ item.realPower }}</div>
                      <div class="label">实时功率(kW)</div>
                    </div>
                    <div class="item">
                      <div class="val">{{ item.eleDayCost }}</div>
                      <div class="label">
                        {{ item.loadType.includes("充电") ? "今日充电成本" : "今日放电收益" }}(元)
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import login from "@/mixins/login";
import {pageParkList, getParkInfo, virtualStationInfo, circulateData, energyFlow} from "@/api/overview";

import fhItemSB from "@/assets/images/fhItemSB.png";
import fhItemPV from "@/assets/images/fhItemPV.png";
import fhItemPW from "@/assets/images/fhItemPW.png";
import fhItemCN from "@/assets/images/fhItemCN.png";
import fhItemRadar from "@/assets/images/fhItemRadar.gif";
import fhItemDCC from "@/assets/images/fhItemDCC.gif";
import fhItemDC from "@/assets/images/fhItemDC.gif";
import phItemY from "@/assets/images/phItemY.png";
import phItemMC from "@/assets/images/phItemMC.gif";
import phItemMM from "@/assets/images/phItemMM.gif";
import phItemMT from "@/assets/images/phItemMT.gif";
import phItemMX from "@/assets/images/phItemMX.gif";
import phItemSC from "@/assets/images/phItemSC.png";
import phItemH from "@/assets/images/phItemH.png";
import phItemC from "@/assets/images/phItemC.png";

import fullScreenChartOption from "./fullScreenChartOption";
import fullScreenChinaJson from "./fullScreenChinaJson.json";
import * as echarts from "echarts";

export default {
  name: "overview",
  mixins: [login],
  data() {
    return {
      mapChart: null,
      workshop: [
        {
          img: fhItemSB,
          title: "50",
          subTitle: "设备数量（台）",
          type: "totalDeviceCount",
        },
        {
          img: fhItemPV,
          title: "315",
          subTitle: "今日发电量（kWh）",
          type: "dayGenerationEle",
        },
        {
          img: fhItemPW,
          title: "3731",
          subTitle: "今日用电量（kWh）",
          type: "dayLoadEle",
        },
        {
          img: fhItemCN,
          title: "284",
          subTitle: "储能电量（kWh）",
          type: "dayStorageEle",
        },
        {
          img: fhItemRadar,
          title: "352.40",
          subTitle: "累计发电量(万kWh)",
          type: "totalEleGeneration",
          noBg: true,
        },
        {
          img: fhItemDC,
          title: "233.53",
          subTitle: "累计用电量(万kWh)",
          type: "totalEleLoad",
          noBg: true,
        },
        {
          img: fhItemDCC,
          title: "43.72",
          subTitle: "储能充电量(万kWh)",
          type: "totalEleStorageIn",
          noBg: true,
        },
        {
          img: fhItemDCC,
          title: "38.29",
          subTitle: "储能放电量(万kWh)",
          type: "totalEleStorageOut",
          noBg: true,
        },
      ],
      eleWorkshop: [
        {
          img: phItemSC,
          title: "5",
          subTitle: "设备数量（台）",
          type: "totalDeviceCount",
        },
        {
          img: phItemY,
          title: "197",
          subTitle: "源设备功率（kW）",
          type: "totalPowerGeneration",
        },
        {
          img: phItemH,
          title: "0.00",
          subTitle: "荷设备功率（kW）",
          type: "totalPowerLoad",
        },
        {
          img: phItemC,
          title: "150",
          subTitle: "储设备功率（kW）",
          type: "totalPowerStorage",
        },
        {
          img: phItemMT,
          title: "0.00",
          subTitle: "可调节功率(kW)",
          noBg: true,
          type: "adjustablePower",
        },
        {
          img: phItemMX,
          title: "200",
          subTitle: "可削峰功率(kW)",
          noBg: true,
          type: "peakClippingPower",
        },
        {
          img: phItemMC,
          title: "0.00",
          subTitle: "可填谷功率(kW)",
          noBg: true,
          type: "grainFillingPower",
        },
        {
          img: phItemMM,
          title: "0.00",
          subTitle: "总收益(元)",
          noBg: true,
          type: "totalIncome",
        },
      ],
      nowYType: "",
      nowHType: "",
      nowCType: "",
      changeTypeTimer: null,
      indexY: 0,
      yDevices: [],
      indexH: 0,
      hDevices: [],
      indexC: 0,
      cDevices: [],
      flowData: {},
      stoStatus: ["待机", "充电中", "放电中"],
    };
  },
  computed: {
    mapOption() {
      return fullScreenChartOption;
    },
  },
  mounted() {
    this.setFontSize();
    window.addEventListener("resize", this.setFontSize);

    echarts.registerMap("china", {geoJson: fullScreenChinaJson});
  },
  beforeDestroy() {
    clearInterval(this.changeTypeTimer);
  },
  methods: {
    setFontSize() {
      const screenWidth =
        document.querySelector(".overview-main") && document.querySelector(".overview-main").offsetWidth;
      const fontSize = (14 * screenWidth) / 1920;
      document.documentElement.style.fontSize = fontSize + "px";
    },
    getData() {
      // this.getPageParkList();
      // this.getParkInfo();
      this.getVirtualStationInfo();
      this.getCirculateData();
      this.getEnergyFlow();
    },
    // 获取地图上的标点
    getPageParkList() {
      pageParkList({
        current: 1,
        size: 99999,
      }).then((res) => {
        let list = res.data.data.records;
        this.mapOption.series.forEach((item) => (item.data = []));
        list.forEach((el) => {
          let params = {
            name: el.name,
            value: [el.longitude, el.latitude],
          };
          this.mapOption.series.forEach((item) => item.data.push(params));
        });
        this.$nextTick(() => {
          this.mapChart = echarts.init(this.$refs.mapChart);
          this.mapChart.setOption(this.mapOption);
        });
      });
    },
    // 获取园区数据
    getParkInfo() {
      getParkInfo().then((res) => {
        if (res && res.data.data) {
          let _data = res.data.data;
          _data.dayGenerationEle = 138;
          for (let key in _data) {
            this.workshop.forEach((item) => {
              if (key == item.type) {
                item.title = _data[key];
              }
            });
          }
        }
      });
    },
    // 获取虚拟电厂数据
    getVirtualStationInfo() {
      virtualStationInfo().then((res) => {
        if (res && res.data.data) {
          let _data = res.data.data;
          for (let key in _data) {
            this.eleWorkshop.forEach((item) => {
              if (key == "totalPowerGeneration") {
                return;
              }
              if (key == "totalPowerStorage") {
                return;
              }
              if (key == "peakClippingPower") {
                return;
              }
              if (key == "totalIncome") {
                return;
              }
              if (key == item.type) {
                item.title = _data[key];
              }
            });
          }
        }
      });
    },
    getCirculateData() {
      Promise.all([
        circulateData({deviceType: 1}),
        circulateData({deviceType: 2}),
        circulateData({deviceType: 3}),
      ]).then((res) => {
        this.yDevices = res[0].data.data;
        this.yDevices = [
          {
            deviceCount: 5,
            deviceCapaCity: 3.7,
            realPower: 1321,
            eleDayConsum: 5814,
            eleDayCost: 4171,
            loadType: "光伏发电",
          },
          {
            deviceCount: 10,
            deviceCapaCity: 64.94,
            realPower: 2016,
            eleDayConsum: 11053,
            eleDayCost: 9716,
            loadType: "风力发电",
          },
          {
            deviceCount: 21,
            deviceCapaCity: 7.95,
            realPower: 2513,
            eleDayConsum: 13027,
            eleDayCost: 11831,
            loadType: "水力发电",
          },
        ];
        this.nowYType = this.yDevices[0].loadType;
        this.hDevices = res[1].data.data;
        this.hDevices = [
          {
            deviceCount: 12,
            deviceCapaCity: 1200,
            realPower: 152,
            eleDayConsum: 825,
            eleDayCost: 631,
            loadType: "生产负荷",
          },
          {
            deviceCount: 15,
            deviceCapaCity: 280,
            realPower: 85.3,
            eleDayConsum: 304.3,
            eleDayCost: 208,
            loadType: "照明负荷",
          },
          {
            deviceCount: 8,
            deviceCapaCity: 1000,
            realPower: 261,
            eleDayConsum: 1571,
            eleDayCost: 1287,
            loadType: "空调负荷",
          },
        ];
        this.nowHType = this.hDevices[0].loadType;
        this.cDevices = res[2].data.data;
        this.cDevices = [
          {
            deviceCount: 12,
            deviceCapaCity: 1480,
            realPower: 0,
            eleDayConsum: 1375,
            eleDayCost: 395.4,
            loadType: "充电数据",
          },
          {
            deviceCount: 12,
            deviceCapaCity: 1480,
            realPower: 0,
            eleDayConsum: 1163,
            eleDayCost: 1012,
            loadType: "放电数据",
          },
        ];
        this.nowCType = this.cDevices[0].loadType;

        this.changeTypeTimer = setInterval(() => {
          this.onYTypeChange();
        }, 5000);
      });
    },

    onYTypeChange() {
      const staY = this.yDevices.map((x) => x.loadType);
      this.indexY++;
      this.indexY > 2 ? (this.indexY = 0) : null;
      this.nowYType = staY[this.indexY];

      const staH = this.hDevices.map((x) => x.loadType);
      this.indexH++;
      this.indexH > 2 ? (this.indexH = 0) : null;
      this.nowHType = staH[this.indexH];

      const staC = this.cDevices.map((x) => x.loadType);
      this.indexC++;
      this.indexC > 1 ? (this.indexC = 0) : null;
      this.nowCType = staC[this.indexC];
    },

    getEnergyFlow() {
      energyFlow({
        parkId: "1606093333678112770",
      }).then((res) => {
        this.flowData = res.data.data;
      });
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/tools";

.img-cover-norepeat {
  background-size: 100%;
  background-repeat: no-repeat;
  background-origin: content-box;
}
.overview-main {
  background: url("../assets/images/bg.png");
  background-size: 100% 100%;
  //height: 100%;
  height: 1080px;
  display: flex;
  flex-direction: column;
  font-family: Arial, sans-serif;
  color: #fff;
  .sys-title {
    height: 96px;
    line-height: 96px;
    text-align: center;
    font-size: 36px;
    background: url("../assets/images/sysTitbg.png");
    background-size: 100% 100%;
  }
  .main-content {
    flex: 1;
    display: grid;
    grid-template-columns: 548px 1fr 548px;
    grid-template-rows: 560px 1fr;
    grid-gap: 40px 98px;
    padding: 20px 40px;
    .div1 {
      grid-area: 1 / 1 / 2 / 3;
    }
    .div3 {
      grid-area: 1 / 3 / 2 / 4;
    }
    .div4 {
      grid-area: 2 / 1 / 3 / 2;
    }
    .div5 {
      grid-area: 2 / 2 / 3 / 3;
    }
    .div6 {
      grid-area: 2 / 3 / 3 / 4;
    }
    & > div {
      display: flex;
      flex-direction: column;
      & > .title {
        background: url("../assets/images/fhTitle.png");
        background-size: 100% 100%;
        height: 36px;
        line-height: 36px;
        font-size: 20px;
        padding-left: 40px;
      }
      & > .content {
        flex: 1;
      }
    }
    .div1 {
      //background: url("../assets/images/yqbg2.png") no-repeat center center;
      //background-size: 975px 536px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      img {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 976px;
        height: 536px;
        transform: translateX(-488px) translateY(-268px);
      }
      .charge-tip {
        width: 152px;
        height: 96px;
        background-image: url("../assets/images/ck.png");
        background-size: 100% 100%;
        z-index: 3;
        position: absolute;
        top: 10px;
        left: 382px;
        padding-top: 10px;
        padding-left: 60px;
      }
      .gen-tip {
        width: 152px;
        height: 96px;
        background-image: url("../assets/images/ck.png");
        background-size: 100% 100%;
        z-index: 3;
        position: absolute;
        top: 10px;
        right: 120px;
        padding-top: 10px;
        padding-left: 60px;
      }
      .grid-tip {
        width: 152px;
        height: 96px;
        background-image: url("../assets/images/wk.png");
        background-size: 100% 100%;
        z-index: 3;
        position: absolute;
        bottom: 86px;
        right: 10px;
        padding-top: 10px;
        padding-left: 60px;
      }
      .load-tip {
        width: 200px;
        height: 96px;
        background-image: url("../assets/images/hk.png");
        background-size: 100% 100%;
        z-index: 3;
        position: absolute;
        bottom: 8px;
        left: 492px;
        padding-top: 10px;
        padding-left: 10px;
      }
      .storage-tip {
        width: 200px;
        height: 116px;
        background-image: url("../assets/images/cnk.png");
        background-size: 100% 100%;
        z-index: 3;
        position: absolute;
        bottom: 156px;
        left: 10px;
        padding-top: 10px;
        padding-left: 10px;
      }
      .tip {
        .tit {
          font-size: 16px;
          color: #00ffbb;
          font-weight: 500;
        }
        .text {
          font-size: 14px;
        }
      }
    }
    .div3 {
      & > .content {
        width: 100%;
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;
        padding-top: 28px;

        .x-item {
          width: 48%;
          height: 20%;
          @extend .img-cover-norepeat;
          background-image: url("../assets/images/fhItemBg.png");
          background-position: center center;
          background-size: 100% 100%;
          display: flex;
          align-items: center;
          justify-content: start;

          &.no-bg {
            background-image: none;

            .x-item-replace {
              padding: rem(20) 0px;
            }

            .x-item-img {
              width: 7rem;
            }
          }
        }

        .x-item-replace {
          display: flex;
          align-items: center;
          flex-flow: row nowrap;
          padding: rem(10);
          padding-right: 0px;
          padding-left: 1.714rem;
        }

        .x-item-img {
          width: 3rem;
        }

        .item-value-con {
          margin-left: rem(20);
          .x-item-title {
            font-size: 30px;
            font-weight: 600;
            color: #00eeff;
            &.color1 {
              color: #34ffb0;
            }
          }
          .x-item-subTitle {
            font-size: 16px;
          }
        }
      }
    }
    .div4,
    .div5,
    .div6 {
      & > .title {
        margin-bottom: 10px;
      }
      & > .content {
        display: flex;
        border-radius: 4px;
        background: linear-gradient(180deg, rgba(17, 37, 97, 0.51) 0%, rgba(48, 77, 166, 0) 100%);
        position: relative;

        /* 定义过渡效果 */
        .slide-enter-active,
        .slide-leave-active {
          transition: opacity 0.5s, transform 0.5s;
        }
        .slide-enter, .slide-leave-to /* .slide-leave-active in <2.1.8 */ {
          opacity: 0;
          transform: translateX(30px);
        }

        .device-info-card {
          width: 100%;
          display: flex;
          padding: 16px 20px;
          box-sizing: border-box;
          position: absolute;
          top: 0;
          left: 0;
          & > div:first-child {
            width: 200px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            img {
              width: 200px;
            }
            .num {
              color: #00eeff;
              font-size: 26px;
              font-weight: bold;
            }
          }
          & > div:last-child {
            flex: 1;
            margin-left: 38px;
            display: flex;
            flex-direction: column;
            .type-name {
              color: #00ffbb;
              font-size: 18px;
              font-weight: bold;
              text-align: center;
            }
            .con {
              flex: 1;
              display: flex;
              margin-top: 28px;
              .col + .col {
                margin-left: auto;
              }
              .col .item {
                & + .item {
                  margin-top: 20px;
                }
                .val {
                  color: #00eeff;
                  font-size: 26px;
                  font-weight: bold;
                }
                .label {
                  font-size: 16px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
